/* @begin tools\lib\annotation\resource\Parser {
	"id": {
		"type": "js",
		"name": "aptis.restCommunicator",
		"precedence": 1
	}
} @end tools\lib\annotation\resource\Parser */
aptis.RestCommunicator = new Class({

	/**
	 * @var {String}
	 */
	_baseUrl: '',

	/**
	 * @param {String} baseUrl
	 */
	initialize: function (baseUrl) {
		this._baseUrl = baseUrl;
	},

	/**
	 * @param {String} url
	 * @param {Function} mainCallback
	 */
	getRequest: function (url, mainCallback) {
		var me = this;
		$j.ajax({
			type: 'GET',
			url: url,
			contentType: 'application/json',
			headers: {
				'X-CSRF-Token': window.yii.getCsrfToken()
			},
			success: function (responseString) {
				mainCallback(null, responseString);
			},
			error: function (jqXHR, textStatus, errorThrown) {
				mainCallback(me._getErrorTextFromResponse(jqXHR, textStatus, errorThrown));
			}
		});
	},

	/**
	 * @param {String} url
	 * @param {Object} data
	 * @param {Function} mainCallback
	 * @param {Number=} ignoreErrorStatusCode
	 */
	postRequest: function (url, data, mainCallback, ignoreErrorStatusCode) { //Falls ignoreErrorStatusCode gesetzt ist, wird beim Response dieser Error ignoriert und kein Fehler zurückgegeben
		var me = this;

		console.log('%c REST ', 'color:black; background: yellow; font-weight:bold');

		$j.ajax({
			type: 'POST',
			//url: this._baseUrl + url,
			url: url,
			dataType: 'json',
			contentType: 'application/json',
			data: JSON.stringify(data),
			headers: {
				//'X-CSRF-Token': window.yii.getCsrfToken()
			},
			beforeSend: function () {
				$(".loading-spinner").addClass('visible');
				$('.loader-wrapper-cross').addClass('is-active');
				$('.spinner-background-wrapper').addClass('is-active');
			},
			success: function (responseString) {
				console.log('success!');
				console.log(responseString);
				mainCallback(null, responseString);
				return responseString;
			},
			error: function (jqXHR, textStatus, errorThrown) {
				console.log('error!');
				var resultData = jqXHR.responseJSON || jqXHR.responseJSON || jqXHR.responseText || null;
				console.log('resultData: ', resultData);
				if (ignoreErrorStatusCode && jqXHR.status === ignoreErrorStatusCode) {
					mainCallback(ignoreErrorStatusCode, resultData);
				} else {
					mainCallback(me._getErrorTextFromResponse(jqXHR, textStatus, errorThrown), resultData);
				}
			},
			complete: function (e, a) {
				console.log('complete', e, a);
				$(".loading-spinner").removeClass('visible');
				$('.loader-wrapper-cross').removeClass('is-active');
				$('.spinner-background-wrapper').removeClass('is-active');
			}
		});

	},

	/**
	 * @param {String} url
	 * @param {Function} mainCallback
	 */
	deleteRequest: function (url, mainCallback) {
		var me = this;
		$j.ajax({
			type: 'DELETE',
			url: this._baseUrl + url,
			contentType: 'application/json',
			headers: {
				'X-CSRF-Token': window.yii.getCsrfToken()
			},
			success: function (responseString) {
				mainCallback(null, responseString);
			},
			error: function (jqXHR, textStatus, errorThrown) {
				mainCallback(me._getErrorTextFromResponse(jqXHR, textStatus, errorThrown));
			}
		});
	},

	/**
	 * @param {String} url
	 * @param {Object} data
	 * @param {Function} mainCallback
	 */
	putRequest: function (url, data, mainCallback) {
		var me = this;
		$j.ajax({
			type: 'PUT',
			url: this._baseUrl + url,
			dataType: 'json',
			contentType: 'application/json',
			headers: {
				"Content-Type": "application/json",
				'X-CSRF-Token': window.yii.getCsrfToken()
			},
			data: JSON.stringify(data),
			success: function (responseString) {
				mainCallback(null, responseString);
			},
			error: function (jqXHR, textStatus, errorThrown) {
				mainCallback(me._getErrorTextFromResponse(jqXHR, textStatus, errorThrown));
			}
		});
	},

	/**
	 *
	 * @param {String} jqXHR
	 * @param {String} textStatus
	 * @param {String} errorThrown
	 * @returns {String}
	 * @private
	 */
	_getErrorTextFromResponse: function (jqXHR, textStatus, errorThrown) {
		if (jqXHR && jqXHR.responseText && jqXHR.responseText !== '') {
			return jqXHR.responseText;
		} else if (errorThrown && errorThrown !== '') {
			return errorThrown;
		} else {
			if (window.console) {
				console.error('Error on _getErrorTextFromResponse():', jqXHR, textStatus, errorThrown);
			}
			return 'Unknown error.';
		}
	}
});